import { Action } from 'redux';
import { HELPER_SET_PAGE_ACTION_TYPE } from '../../constants/actionTypes';
import { IBreadcrumb, TPage } from '../../types/helper';
import { STEPS } from '../../constants/page-content';
import { EVENTS_BY_PAGE } from '../../constants/events';
import { clickBlock } from '../../utils/events';

export type THelperActionType = 'HELPER/SET_PAGE';

export interface ISetPage extends Action<THelperActionType> {
  breadcrumbs?: IBreadcrumb[];
  type: THelperActionType;
  page: TPage;
}

export function redirectPage(page: TPage) {
  clickBlock(EVENTS_BY_PAGE[page]);
  if (typeof window !== 'undefined' && window && window.location && window.location.href) {
    window.location.href = window.location.origin + window.location.pathname + '?step=' + page;
  } else {
    setPage(page);
  }
}

/**
 * Redux action, который записывает в store текущую страницу
 * @param page TPage
 */
export function setPage(page: TPage): ISetPage {
  try {
    history.pushState(null, '', `?step=${page}`);
  } catch (e) {}

  return {
    breadcrumbs: getBreadcrumbsByPage(page),
    page,
    type: HELPER_SET_PAGE_ACTION_TYPE,
  };
}

/**
 * По странице вычисляем хлебные крошки для неё
 * @param page
 */
export function getBreadcrumbsByPage(page: TPage): IBreadcrumb[] {
  if (page !== 'main') {
    const curPage = STEPS.find(step => step.page === page);

    if (curPage !== undefined) {
      return [
        {
          page: 'main' as TPage,
          title: 'Продажа квартиры на вторичном рынке',
        },
        curPage as IBreadcrumb,
      ];
    }
  }

  return [
    {
      page: 'main' as TPage,
      title: 'Продажа квартиры на вторичном рынке',
    },
  ];
}
